import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { filterBoolean } from '@recruitee/common';

import { FeatureFlagSelectors } from './store/feature-flags.store';
import { FeatureFlag, FeatureFlagsMap } from './types';

@Injectable({ providedIn: 'root' })
export class Feature {
  public readonly loaded$ = this.store.select(FeatureFlagSelectors.isLoaded);
  private features?: FeatureFlagsMap;

  constructor(private store: Store) {
    this.store
      .select(FeatureFlagSelectors.data)
      .pipe(filterBoolean)
      .subscribe(data => {
        this.features = data;
      });
  }

  /**
   * @deprecated Use @recruitee/feature-flags
   */
  public isEnabled(name: FeatureFlag): boolean {
    if (!this.features) return false;

    return this.features[name];
  }
}
